import { render, staticRenderFns } from "./CaseSection.vue?vue&type=template&id=4f524656&scoped=true"
import script from "./CaseSection.vue?vue&type=script&lang=ts"
export * from "./CaseSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f524656",
  null
  
)

export default component.exports